import { useState } from 'react';
import { IconButton, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { MakeCopy } from 'ui/icons/action/MakeCopy';
import { StyledIconCont, StyledMetadataListItem } from './ProjectMetadata.styled';
import { copyString, getValue } from './utils';

export const MetadataListItem = ({ id, val }: { id: string; val: string }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <StyledMetadataListItem
      key={id}
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}
    >
      {val}
      <StyledIconCont>
        {isActive && (
          <IconButton
            variant={BUTTON_VARIANTS.GHOST}
            size={BUTTON_SIZES.SMALL}
            onClick={() => copyString(getValue(val))}
          >
            <MakeCopy height={14} width={14} />
          </IconButton>
        )}
      </StyledIconCont>
    </StyledMetadataListItem>
  );
};
